import { render, staticRenderFns } from "./ContentChildrenMenu.vue?vue&type=template&id=c0c648b8&scoped=true"
import script from "./ContentChildrenMenu.vue?vue&type=script&lang=js"
export * from "./ContentChildrenMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c648b8",
  null
  
)

export default component.exports